module.exports = __webpack_public_path__ + "static/media/CL.0c24e824.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/CL.svg
// module id = 225
// module chunks = 0